module.exports = __webpack_public_path__ + "static/media/c1_mobile.57bc7dbb.png";